import Vue from 'vue';

import axios from 'axios';
import qs from 'qs';

// 引入Antd
import { message } from 'ant-design-vue';

if (
  window.localStorage.getItem('token') != null &&
  window.localStorage.getItem('token') != ''
) {
  axios.defaults.headers['Authorization'] = window.localStorage.getItem(
    'token'
  );
}
axios.defaults.baseURL = 'https://api.ycrmt.cn/';
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';

// request拦截器,加入公用参数
axios.interceptors.request.use(
  function (config) {
    let siteid = 0;
    if (
      window.localStorage.getItem('siteinfo') != null &&
      window.localStorage.getItem('siteinfo') != ''
    ) {
      let setSiteInfo = JSON.parse(window.localStorage.getItem('siteinfo'));
      siteid = setSiteInfo.site_id;
    }
    if (
      window.localStorage.getItem('token') != null &&
      window.localStorage.getItem('token') != ''
    ) {
      axios.defaults.headers['Authorization'] = window.localStorage.getItem(
        'token'
      );
    }
    if (config.method === 'post') {
      let data = qs.parse(config.data);
      config.data = qs.stringify({
        siteid: siteid,
        ...data
      });
    } else if (config.method === 'get') {
      config.params = {
        siteid: siteid,
        ...config.params
      };
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// response拦截器，判断基本状态
axios.interceptors.response.use(
  response => {
    // 定时刷新access-token
    if (response.status && response.status === 200) {
      if (response.data.state === 401) {
        message
          .error('登录超时，请重新登录')
          .then(
            () =>
              (location.href = 'https://uc.cn3x.com.cn/index.php/login/index')
          );
        // // 刷新token
        // store.dispatch('refresh').then(response => {
        //     sessionStorage.setItem('access_token', response.data)
        // }).catch(error => {
        //     throw new Error('token刷新' + error)
        // })
      } else if (response.data.state != 200) {
        // message.warn(response.data.message)
      }
    } else {
    }
    return response;
  },
  error => {
    if (error.response.status === 404) {
      message.error('请求无效');
    } else if (error.response.status === 403) {
      message.error('权限不足,请联系管理员!');
    } else if (error.response.status === 502) {
      message
        .error('登录超时，请重新登录!')
        .then(
          () => (location.href = 'https://uc.cn3x.com.cn/index.php/login/index')
        );
    } else {
      // message.error('服务器错误，请重新登录!').then(()=>location.href = '/login');
    }
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
export default () => { };
